import { env } from './env'

export const API_BASE_URL = env.VITE_API_BASE_URL.replace(/\/$/, '')
